module.exports = __webpack_public_path__ + "static/media/Mopex S.ad273d9a.jpeg";